import EnumObject from '@/domain/enum-object.entity';
import Currency from '@/domain/currency/entity/currency.entity';
import ContractsDetailed from './billing-detailed-entitys.ts/contracts-detailed-entity';
import ItemsDetailed from './billing-detailed-entitys.ts/items-detailed.entity';
import GenericDetailed from './billing-detailed-entitys.ts/generic-detailed.entity';
import PaymentsDetailed from './billing-detailed-entitys.ts/payments-detailed.entity';

export default class BillingDetailed {
  id: string;

  invoiceCreatedAt: string;

  invoiceId: string;

  invoiceNumber: string;

  invoiceValue: string;

  competenceMonth: string

  competenceYear: string;

  customerName: string;

  customerDocument: string;

  customerExternalId: string;

  paymentDueAt: string;

  paymentPaidAt: string;

  invoiceWithHoldingTaxValue: string;

  paymentDiscountValue: string;

  paymentInterestValue: string;

  paymentPaidValue: string;

  payeeName: string;

  netValue: string;

  paymentOpenValue: string;

  updatedAt: string;

  status: EnumObject;

  contracts: ContractsDetailed[] = [];

  items: ItemsDetailed[] = [];

  businessUnits: GenericDetailed[] = [];

  resultCenters: GenericDetailed[] = [];

  payments: PaymentsDetailed[] = [];

  customerTradingName: string;

  currency: Currency;

  content: any;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.invoiceCreatedAt = obj.invoiceCreatedAt;
    this.invoiceId = obj.invoiceId;
    this.invoiceNumber = obj.invoiceNumber;
    this.invoiceValue = obj.invoiceValue;
    this.competenceMonth = obj.competenceMonth;
    this.competenceYear = obj.competenceYear;
    this.customerName = obj.customerName;
    this.customerDocument = obj.customerDocument;
    this.customerExternalId = obj.customerExternalId;
    this.paymentDueAt = obj.paymentDueAt;
    this.paymentPaidAt = obj.paymentPaidAt;
    this.invoiceWithHoldingTaxValue = obj.invoiceWithHoldingTaxValue;
    this.paymentDiscountValue = obj.paymentDiscountValue;
    this.paymentInterestValue = obj.paymentInterestValue;
    this.paymentPaidValue = obj.paymentPaidValue;
    this.paymentOpenValue = obj.paymentOpenValue;
    this.payeeName = obj.payeeName;
    this.netValue = obj.netValue;
    this.updatedAt = obj.updatedAt;
    this.customerTradingName = obj.customerTradingName;
    this.status = EnumObject.of(obj.status);
    if (obj.contracts) this.contracts = ContractsDetailed.ofList(obj.contracts);
    if (obj.items) this.items = ItemsDetailed.ofList(obj.items);
    if (obj.businessUnits) this.businessUnits = GenericDetailed.ofList(obj.businessUnits);
    if (obj.resultCenters) this.resultCenters = GenericDetailed.ofList(obj.resultCenters);
    if (obj.payments) this.payments = PaymentsDetailed.ofList(obj.payments);
    this.currency = Currency.of(obj.currency);
    this.content = obj.content ? JSON.parse(obj.content) : {};
  }

  public static of(obj: any = {}): BillingDetailed {
    return new BillingDetailed(obj);
  }

  public static ofList(obj: any[]): BillingDetailed[] {
    return obj.map(this.of);
  }

  public get statusValue(): string {
    return this.status.description;
  }

  public get statusColor(): string {
    switch (this.status.value) {
      case 'PRE_BILLED':
        return '#2F80ED';
      case 'TO_RECEIVE':
        return '#F2C94C';
      case 'RECEIVED':
        return '#189F51';
      case 'DEFAULTING':
        return '#BB452C';
      case 'CANCELED':
        return '#FF3306';
      default:
        return 'black';
    }
  }

  public get isUnpaid(): boolean {
    return this.status.value === 'DEFAULTING';
  }

  get contractsJoined(): string {
    return this.contracts.map((el: ContractsDetailed) => `${el.number}`).join(', ')
  }

  get resultCentersGrouped(): string {
    const length = this.resultCenters.length;
    return length > 1 ? `${length} Itens` : this.resultCenters[0].name;
  }

  get resultCentersJoined(): string {
    return this.resultCenters.map((el: GenericDetailed) => `${el.name}`).join(', ')
  }

  get itemsGrouped(): string {
    const length = this.items.length;
    return length > 1 ? `${length} Itens` : this.items[0].description;
  }

  get itemsJoined(): string {
    return this.items.map((el: ItemsDetailed) => `${el.description}`).join(', ')
  }

  get competence() {
    return `${this.competenceMonth}/${this.competenceYear}`
  }

  get isPreInvoice(): boolean {
    return this.status.value === 'PRE_INVOICE';
  }
}
